import ChatPage, { getDefaultPageUI, getDefaultPageData } from "components/pages/ChatPage";
import { BCMSStateManagerCRUD, BCMSDate } from "bcms-react";
import ChatItem from "components/pages/ChatPage/classes/ChatItem";

export default function CaptureChatUserQuestionSent(props) {
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "showInitialMessage" ], false)
        .submit();

    const date = BCMSDate.init();
    const response = ChatItem.init("Hi, there! How can I help you?", "received", date, 0)
    const question = ChatItem.init("Hi! I'm looking for my profile information.", "sent", date, 5)

    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
        .update([ "messages" ], [ response, question ])
        .submit();

    return <ChatPage ui={ ui } data={ data } />
}